import { BoothItem } from '../data/boothFood';
import { BoothDetailRawData } from '../services/apis/booth/boothDetail';

export const boothListMock: BoothItem[] = [
  {
    dayBoothNum: 1,
    name: '도토리 굿즈샵',
    owner: '미디어학부',
    categories: ['물품 판매'],
    recommendNum: 12,
    location: '정문일대',
    type: 'booth',
  },
  {
    dayBoothNum: 2,
    name: '타로 부스',
    owner: '심리학과',
    categories: ['체험 / 홍보'],
    recommendNum: 24,
    location: '해방광장',
    type: 'booth',
  },
  {
    dayBoothNum: 3,
    name: '물풍선 던지기',
    owner: '기계공학과',
    categories: ['이벤트 / 게임'],
    recommendNum: 7,
    location: '정문일대',
    type: 'booth',
  },
  {
    dayBoothNum: 4,
    name: '지구를 지켜라',
    owner: '환경공학부',
    categories: ['캠페인'],
    recommendNum: 13,
    location: '104관 계단',
    type: 'booth',
  },
  {
    dayBoothNum: 5,
    name: '악기 체험존',
    owner: '음악학부',
    categories: ['소 연주회'],
    recommendNum: 18,
    location: '해방광장',
    type: 'booth',
  },
  {
    dayBoothNum: 6,
    name: '한복 체험',
    owner: '국문학과',
    categories: ['체험 / 홍보'],
    recommendNum: 22,
    location: '정문일대',
    type: 'booth',
  },
  {
    dayBoothNum: 7,
    name: '벼룩시장',
    owner: '경제학부',
    categories: ['물품 판매'],
    recommendNum: 9,
    location: '해방광장',
    type: 'booth',
  },
  {
    dayBoothNum: 8,
    name: '게임랜드',
    owner: '컴퓨터공학과',
    categories: ['이벤트 / 게임'],
    recommendNum: 30,
    location: '104관 계단',
    type: 'booth',
  },
  {
    dayBoothNum: 9,
    name: '소셜 캠페인',
    owner: '사회학과',
    categories: ['캠페인'],
    recommendNum: 5,
    location: '해방광장',
    type: 'booth',
  },
  {
    dayBoothNum: 10,
    name: '요리 체험',
    owner: '식품영양학과',
    categories: ['음식 판매'],
    recommendNum: 16,
    location: '정문일대',
    type: 'booth',
  },
];

export const boothDetailMock: BoothDetailRawData[] = [
  {
    dayBoothNum: 1,
    name: '세라오락관',
    owner: '간호학부',
    info: '세라오락관에서 오락하고 가세용용',
    cover: '/images/mock/boothMock.png',
    location: '정문일대',
    categories: ['SALE'],
    boothReview: [{ FUN: 12 }, { RECOMMEND: 10 }, { BENEFICIAL: 8 }],
    boothId: 101,
    opDateList: [19, 21],
    opTimeStart: 1100,
    opTimeEnd: 1700,
  },
];
